<div class="flex items-center justify-center pt-32 mb-0">
  <div class="container mx-auto flex flex-col lg:flex-row items-center px-5">

    <div class="lg:w-1/2 text-center lg:text-start space-y-5">
      <h1 class="uppercase text-[#4B227A] font-bold text-2xl md:text-3xl lg:text-5xl leading-tight">
        REVISION NOTES TO <br class="lg:block hidden" /> BOOST YOUR GRADES
      </h1>
      <p class=" lg:text-lg text-[#2D2E32] leading-[1.8]  mx-auto lg:mx-0">
        Our revision notes are carefully developed around exam specifications, covering all the
        topics you need to cover. Packed with clear examples, examiner tips, and engaging
        pictures and videos, they’re designed to fill knowledge gaps and help you improve your
        grades efficiently
      </p>

      <!-- <div class="flex justify-center lg:justify-start gap-4">
        <app-main-btn [btnTxColor]="'white'" [borderColor]="'primary'" [btnColor]="'primary'" [btnName]="'Explore Revision Notes'" />
      </div> -->
    </div>

    <div class="lg:w-1/2 mt-10 lg:mt-0 flex justify-center">
      <img src="Images/star.png" alt="star" class="w-[80%] max-w-sm lg:max-w-full" />
    </div>

  </div>
</div>